import './App.scss';
import React from 'react';
import Lottie from 'lottie-react';
import MainApp from './MainApp';
import Showcase from './Showcase/src/showcase.jsx'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import useSanity from './customHooks/useSanity';

import LoadingAnimation from './assets/MainLoading.json';
const App = () => {
  const { loading } = useSanity();
  if (loading) {
    return (
    <div className="flex justify-center items-center h-screen">
      <Lottie
        className="w-1/4"
        animationData={LoadingAnimation}
        loop
      />
    </div >
      )
  }
  return (
    <Router>
      
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/showcase/:projectId" element={<Showcase />} />
      </Routes>
    </Router>
  );
}

export default App;
